import swal from 'sweetalert';
import I18n from 'i18n-js';
import Rails from '@rails/ujs';
import $ from "jquery";

// window.swal = swal;
$(document).on('turbolinks:load', function () {
    // Behavior after click to confirm button
    const confirmed = (element, result) => {
        // If result `success`
        // it (result.value); {
            // Removing attribute for unbinding JS event.
            // element.removeAttribute('data-confirm-swal');
            // Following a destination link
            // element.click();
        // }
        element.removeAttribute('data-confirm-swal');
        document.getElementById("submit-btn").click();
    };

    // Display the confirmation dialog
    const showConfirmationDialog = (element) => {
        const message = element.getAttribute('data-confirm-swal');
        const text    = element.getAttribute('data-text');

        swal({
            icon: 'success',
            title: "Validar Requisición",
            text: "Revisar y firmar requisición.",
            buttons: {
                cancel: I18n.t('messages.cancel'),
                confirm: {
                    text: "Confirmar",
                    closeModal: true
                },
            }
        }).then(function (value) {
            if (value) {
                confirmed(element, value)
            }
        });
    };

    const allowAction = (element) => {
        if (element.getAttribute('data-confirm-swal') === null) {
            return true;
        }

        showConfirmationDialog(element);
        return false;
    };

    function handleConfirm(element) {
        if (!allowAction(this)) {
            Rails.stopEverything(element);
        }
    }

    Rails.delegate(document, 'a[data-confirm-swal]', 'click', handleConfirm);
});